import { createContext, ReactNode, use } from 'react'
import useSWR, { SWRResponse } from 'swr'
import { useSupabase } from '@packages/supabase'

type TenantsContextType = SWRResponse & {}

type AdminTenant = Tenant & {
  user_count: number
}

const TenantsContext = createContext<TenantsContextType | undefined>(undefined)

export const TenantsProvider = ({ children }: { children: ReactNode }) => {
  const { supabase } = useSupabase()

  const tenants = useSWR('admin-tenants', async () => {
    return supabase.rpc('admin_fetch_tenants').then(({ data, error }) => {
      if (error) {
        console.error('Error fetching tenants:', error)
        return []
      }
      return (data || []) as AdminTenant[]
    })
  })

  return (
    <TenantsContext.Provider value={{ ...tenants }}>
      {children}
    </TenantsContext.Provider>
  )
}

export const useTenants = () => {
  const context = use(TenantsContext)
  if (!context) {
    throw new Error('useTenants must be used within a TenantsProvider')
  }
  return context
}
